import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  MouseSensor,
  TouchSensor,
  KeyboardSensor,
  type DragEndEvent,
  type Modifier
} from "@dnd-kit/core";
import {
  restrictToHorizontalAxis,
  restrictToVerticalAxis
} from "@dnd-kit/modifiers";

type InternalTableDndContextProps = {
  onDragEnd: (event: DragEndEvent) => void;
  children: React.ReactElement;
  restrictAxis?: "horizontal" | "vertical";
};

/**
 * The wrapper component for the DndContext to handle drag and drop events for the table
 * to handle the ordering of columns and rows
 */
export const InternalTableDndContext = (
  props: InternalTableDndContextProps
) => {
  const { children, onDragEnd, restrictAxis = "horizontal" } = props;

  const sensors = useSensors(
    useSensor(MouseSensor, {}),
    useSensor(TouchSensor, {}),
    useSensor(KeyboardSensor, {})
  );

  const modifiers: Modifier[] = [];
  if (restrictAxis === "horizontal") {
    modifiers.push(restrictToHorizontalAxis);
  } else if (restrictAxis === "vertical") {
    modifiers.push(restrictToVerticalAxis);
  }

  return (
    <DndContext
      collisionDetection={closestCenter}
      modifiers={modifiers}
      onDragEnd={onDragEnd}
      sensors={sensors}
    >
      {children}
    </DndContext>
  );
};
